import styled from "styled-components";

import FallbackImage from "components/global/FallbackImage";

export const PlayerProfileSectionGridLayout = styled.div.attrs({
  className: "mt-8 grid gap-6 xl:grid-cols-[0.8fr_1.2fr]",
})``;

export const PlayerProfileSectionHeroImage = styled(FallbackImage).attrs({
  className: "mx-auto h-32 w-32 max-w-full rounded-[22px] sm:h-44 sm:w-44 sm:rounded-[24px]",
})``;

export const PlayerProfileSectionGridLayoutSecondary = styled.div.attrs({
  className: "grid gap-4 md:grid-cols-2",
})``;

export const PlayerProfileSectionSection = styled.div.attrs({ className: "brand-panel-muted" })``;

export const PlayerProfileSectionEyebrowText = styled.p.attrs({
  className: "text-xs uppercase tracking-[0.2em] text-[var(--brand-muted)]",
})``;

export const PlayerProfileSectionTitleText = styled.p.attrs({
  className: "mt-2 text-lg font-medium text-[var(--brand-ink)]",
})``;

export const PlayerProfileSectionSectionSecondary = styled.div.attrs({ className: "mt-8" })``;
